/* "View more" buttons reveal the next batch of items already in the page. */
(function () {
  function setup(section) {
    // the section tag includes this script once per instance, so guard against
    // binding the same button twice (which would reveal two batches per click)
    if (section.dataset.pressBound === 'true') return;

    var button = section.querySelector('[data-press-more]');
    if (!button) return;

    // two shapes: a list of [hidden] items, or a container the CSS truncates
    // on small screens until it gets the is-expanded class
    var expandable = section.querySelector('[data-press-expand]');
    if (expandable) {
      section.dataset.pressBound = 'true';
      button.addEventListener('click', function () {
        expandable.classList.add('is-expanded');
        var f = button.closest('[data-press-footer]');
        (f || button).hidden = true;
      });
      return;
    }

    var list = section.querySelector('[data-press-list]');
    if (!list) return;

    section.dataset.pressBound = 'true';

    // "all" reveals the whole list in one click ("View all"), a number reveals
    // that many per click ("View more")
    var rawStep = button.getAttribute('data-press-step');
    var revealAll = rawStep === 'all';
    var step = parseInt(rawStep, 10) || 6;

    var hiddenItems = function () {
      return list.querySelectorAll('[data-press-item][hidden]');
    };

    button.addEventListener('click', function () {
      var hidden = hiddenItems();
      if (!hidden.length) return;

      var limit = revealAll ? hidden.length : step;
      var first = null;
      for (var i = 0; i < hidden.length && i < limit; i++) {
        hidden[i].hidden = false;
        if (!first) first = hidden[i];
      }

      // move focus to the first newly shown item so keyboard users keep their place
      if (first) {
        first.setAttribute('tabindex', '-1');
        first.focus({ preventScroll: true });
      }

      // nothing left to reveal: drop the button and its spacing, not just the button
      if (!hiddenItems().length) {
        var footer = button.closest('[data-press-footer]');
        (footer || button).hidden = true;
      }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-press-section]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor re-renders sections on change
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
